/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email.toLowerCase())
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
